var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.cardClasses,on:{"mouseover":function($event){_vm.hover = true},"mouseout":function($event){_vm.hover = false}}},[_vm._t("header"),_vm._t("default"),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }